import { CartLineContext } from "@insite/client-framework/Components/CartLineContext";
import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEvent";
import isEmpty from "lodash/isEmpty";
import { useContext } from "react";

const useItems = (options?: Toolkit.GoogleAnalytics.Options): TrackEventParameters["items"] => {
    const cartLine = useContext(CartLineContext);
    const { cartLines } = ga.use.cart(options) || {};
    const { orderLines } = ga.use.order(options) || {};
    const { invoiceLines } = ga.use.invoice(options) || {};
    const { wishListLineCollection } = ga.use.wishList(options) || {};

    let productContext: ProductContextModel | undefined = useContext(ProductContext);
    productContext = !isEmpty(productContext) ? productContext : undefined;

    return productContext ?? cartLine ?? invoiceLines ?? orderLines ?? wishListLineCollection ?? cartLines ?? undefined;
};

export default useItems;
